import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/lib/AuthContext';
import { I18nProvider } from '@/lib/i18n';
import { App } from '@/components/App';
import { PublicPortal } from '@/pages/publicPortal/PublicPortal';
import './global.scss';
var root = document.getElementById('root');
if (!root) {
    throw new Error('root not found');
}
var router = createBrowserRouter([
    {
        path: '/portal/:token',
        element: (_jsx(I18nProvider, { children: _jsx(PublicPortal, {}) })),
    },
    {
        path: '*',
        element: (_jsx(I18nProvider, { children: _jsx(AuthProvider, { children: _jsx(App, {}) }) })),
    },
]);
createRoot(root).render(_jsx(RouterProvider, { router: router }));
